var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "twitter_24dp-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 328,
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "0418\\u66F4\\u65B0--my-balance\\u5F39\\u7A97--send\\u65B0\\u589E",
    transform: "translate(-1048.000000, -452.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(958.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-40",
    transform: "translate(16.000000, 164.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-41\\u5907\\u4EFD",
    transform: "translate(62.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter_24dp-4",
    transform: "translate(12.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1562402,7.73442548 C19.3913506,13.0609137 15.5182176,19 8.66064622,19 C6.57502657,19 4.63452284,18.373558 3,17.2983388 C4.95962753,17.5348408 6.91475532,16.9776187 8.46715828,15.730503 C6.85063433,15.699354 5.48721954,14.6045224 5.01812386,13.1001385 C5.59746266,13.213198 6.16667708,13.1797416 6.68526967,13.035533 C4.90900569,12.66982 3.68395725,11.0293031 3.72332979,9.27457314 C4.22054872,9.55837564 4.79088807,9.72911863 5.39497532,9.74873097 C3.75145304,8.62159671 3.28573215,6.39501616 4.25204674,4.6922012 C6.07330792,6.98338718 8.79451281,8.49123209 11.863321,8.64928476 C11.3244798,6.28080296 13.0782451,4 15.4619711,4 C16.5227798,4 17.4834698,4.45916014 18.1561778,5.19635441 C18.9976252,5.02676511 19.7884508,4.71181357 20.502781,4.27803416 C20.2260484,5.16289802 19.6410849,5.90470698 18.8795075,6.37309645 C19.6264609,6.28080296 20.3385414,6.07775727 21,5.77664975 C20.5061559,6.53345639 19.8795701,7.20027686 19.1562402,7.73442548 Z",
    id: "\\u5F62\\u72B6-path",
    fill: "currentColor"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.a7ee9516c07416552638b49ad30e0b44.svg";
export { ForwardRef as ReactComponent };